import { Component, OnInit, Input } from '@angular/core';
import { EditorService } from '../../editor.service';
@Component({
  selector: 'app-pagenoposition',
  templateUrl: './pagenoposition.component.html',
  styleUrls: ['./pagenoposition.component.css']
})
export class PagenopositionComponent implements OnInit {
  @Input() data: any;
  selectedPage;
  constructor(private editorService: EditorService) { }

  ngOnInit() {
    let editorPageData = this.editorService.editorPageData;
    if (editorPageData && editorPageData.pageNumber) {
      this.selectedPage = JSON.parse(this.editorService.editorPageData.pageNumber).position;
    }
  }

  pageNoicons = [{ "icon": "icon-pagination_top_left", "position": "topLeft" },
  { "icon": "icon-pagination_top_center", "position": "topCenter" }, { "icon": "icon-pagination_top_right", "position": "topRight" }, { "icon": "icon-pagination_bottom_left", "position": "bottomLeft" }, { "icon": "icon-pagination_bottom_center", "position": "bottomCenter" }, { "icon": "icon-pagination_bottom_right", "position": "bottomRight" }];


  setPageNoPosition(pos, cPos) {
    this.selectedPage = cPos;
    pos = (pos + 1).toString();
    let pageNo;
    if (this.data.popupProps.curComp.pageObj.pageNumber) {
      pageNo = this.data.popupProps.curComp.pageObj.pageNumber;
    }
    let obj: any = {
      'value': pageNo,
      'visible': 'true',
      'position': pos
    }
    let layer = this.editorService.getIframeReference();
    layer.setPageNumber(obj);

  }


}



// WEBPACK FOOTER //
// ./src/app/bookShared/bookeditoption/bookEditOptionPopups/pagenoposition/pagenoposition.component.ts